/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import AuthService from '../../services/AuthService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import Message from '../general/Message';
import GeneralNavbar from '../general/GeneralNavbar';

const SignUp = props => {
    // contexts
    const { theme, fontFamily, fontSize, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [user, setUser] = useState({ firstName: "", lastName: "", email: "", password: "", confirmPassword: "" });
    const [dateBeforeYears, setDateBeforeYears] = useState(moment());
    const [minimumAge, setMinimumAge] = useState(0);
    const [message, setMessage] = useState({ msgBody: '', msgError: false });
    const [isLoading, setIsLoading] = useState(false);
    let timerID = useRef(null);

    useEffect(() => {
        // document.getElementById("firstname").focus();
        document.getElementById("form-input-firstname").focus();
        if (props.location.state && props.location.state.email) {
            setUser({ ...user, email: props.location.state.email });
        }
        if (props.location.state && props.location.state.message) {
            setMessage(props.location.state.message);
        }
        GeneralService.getMinimumAge().then(data => {
            try {
                setDateBeforeYears(dateBeforeYears.subtract(data.minimumAge, 'years'));
                setMinimumAge(data.minimumAge);
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                GeneralService.logError('at User SignUp useEffect', 'Error in try catch block', err.stack);
            }
        });
        return () => {
            clearTimeout(timerID)
        }
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [message])

    // Utility functions
    // reset form 
    const resetForm = () => {
        try {
            setUser({ firstName: "", lastName: "", email: "", password: "", confirmPassword: "" });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User SignUp resetForm', 'Error in try catch block', err.stack);
        }
    }

    // handle functions
    const handleChange = e => {
        try {
            setUser({ ...user, [e.target.name]: e.target.value });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User SignUp handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (user.password.length < 6) {
                setMessage({
                    msgBody: "Your password must be at least 6 characters",
                    msgError: true
                })
            } else if (user.password.search(/[a-zA-Z]/i) < 0) {
                setMessage({
                    msgBody: "Your password must contain at least one letter",
                    msgError: true
                })
            } else if (user.password.search(/[0-9]/) < 0) {
                setMessage({
                    msgBody: "Your password must contain at least one digit",
                    msgError: true
                })
            } else if (user.password.search(/[A-Z]/) < 0) {
                setMessage({
                    msgBody: "Your password must contain at least one uppercase letter",
                    msgError: true
                })
            } else if (user.password !== user.confirmPassword) {
                setMessage({
                    msgBody: "Passwords don't match",
                    msgError: true
                })
            } else {
                setIsLoading(true);
                AuthService.registerUser(user).then(data => {
                    const { message } = data;
                    setMessage(message);
                    resetForm();
                    setIsLoading(false);
                    if (!message.msgError) {
                        timerID = setTimeout(() => {
                            props.history.push({ pathname: '/user/signin', state: { email: user.email } });
                        }, 2000)
                    }
                })
                    .catch(error => {
                        setMessage(error.message)
                        if (error.userExists) {
                            timerID = setTimeout(() => {
                                props.history.push({ pathname: '/user/signin', state: { email: user.email } });
                            }, 2000)
                        }
                        setIsLoading(false);
                    })
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at User SignUp handleSubmit', 'Error in try catch block', err.stack);
        }
    }


    // function's return
    return (
        <div>
            <ErrorBoundary errorAt="At User SignUp GeneralNavbar">
                <GeneralNavbar history={props.history} />
            </ErrorBoundary>
            <div className="col-md-4 py-5 offset-md-4">
                <div className="p-3" style={theme.form}>
                    <form onSubmit={handleSubmit} style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                        <h2 id="sign-up-heading" style={theme.heading}>Sign Up an account</h2>
                        <br />

                        <ErrorBoundary errorAt="At User SignUp Message">
                            {message.msgBody ? <Message message={message} /> : null}
                        </ErrorBoundary>

                        <ErrorBoundary errorAt="At User SignUp FormFields">
                            <label htmlFor="firstName" style={theme.formBodyText} id="form-label-firstname">Firstname </label>
                            <input type="text"
                                id="form-input-firstname"
                                name="firstName"
                                value={user.firstName}
                                onChange={handleChange}
                                className="form-control"
                                required
                                style={theme.formInput}
                            />
                            <br />

                            <label htmlFor="lastName" style={theme.formBodyText} id="form-label-lastname">Lastname </label>
                            <input type="text"
                                id='form-input-lastname'
                                name="lastName"
                                value={user.lastName}
                                onChange={handleChange}
                                className="form-control"
                                required
                                style={theme.formInput}
                            />
                            <br />

                            <label htmlFor="email" style={theme.formBodyText} id="form-label-email">Email </label>
                            <input type="email"
                                id='form-input-eamil'
                                name="email"
                                value={user.email}
                                onChange={handleChange}
                                className="form-control"
                                required
                                style={theme.formInput}
                            />
                            <br />

                            <label htmlFor="password" style={theme.formBodyText} id="form-label-password">Password </label>
                            <input type="password"
                                id='form-input-passowrd'
                                name="password"
                                value={user.password}
                                onChange={handleChange}
                                className="form-control"
                                required
                                style={theme.formInput}
                            />
                            <br />


                            <label htmlFor="confirmPassword" style={theme.formBodyText} id="form-label-conf-password">Confirm Password </label>
                            <input type="password"
                                id='form-input-conf-password'
                                name="confirmPassword"
                                value={user.confirmPassword}
                                onChange={handleChange}
                                className="form-control"
                                required
                                style={theme.formInput}
                            />
                            <br />
                        </ErrorBoundary>

                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*Password must have at least 6 characters with one alphabet, one digit and one uppercase</p>
                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*After sign up a mail will be send to your email address for verification</p>
                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*By clicking on Sign Up button below you indicate that you are at least {minimumAge} years of age as of today (Date of Birth before {dateBeforeYears.format('DD/MM/YYYY')}).</p>
                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*By clicking on Sign Up button below you indicate that you agree to our <Link to='/termsconditions'><u>Terms &#38; Conditions</u></Link>, <Link to='/privacypolicy'><u>Privacy Policy</u></Link> and <Link to='/cookiepolicy'><u>Cookie Policy</u></Link>.</p>

                        <button className="btn mt-2" type="submit" style={theme.formSubmit} disabled={isLoading} id="sign-up-btn">{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Sign Up</button>

                    </form>
                </div>
            </div>
        </div>
    )


}

export default SignUp;